export const THEME_MODE = {
  DARK: 'dark',
  LIGHT: 'light',
} as const;
export type ThemeMode = typeof THEME_MODE[keyof typeof THEME_MODE];
export const THEME_LS_KEY = 'theme';
